import { MutationType } from '@tencent/slide-sdk-pb-model';
import type { ISectionData } from '../data';
import type { IValidAddSectionMutationData, IValidBindSectionToSlideMutationData } from '../mutation/base';
import type { KeyframeContext } from './keyframe-context.interface';

export function getSectionKeyframe(
    section: ISectionData,
    context: Omit<KeyframeContext, 'presentation'> & { presentation?: { slideList: { id: string }[] } },
): [IValidAddSectionMutationData, IValidBindSectionToSlideMutationData] {
    const index = context.presentation?.slideList.findIndex((slide) => slide.id === section.firstSlideId) ?? 0;
    return [
        { type: MutationType.AddSection, sectionId: section.id, name: section.name },
        {
            type: MutationType.BindSectionToSlide,
            sectionId: section.id,
            firstSlideIndex: index >= 0 ? index : context.presentation?.slideList.length ?? 0,
        },
    ];
}
